// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3xuiS","content":"GlobalSearch_content__jcw7y"};